import ImageView from './components/ImageView';
import { assetErrorImage, imageName, imageTooltip } from './imagepickerStrings.locstring.json';
import type { ImagePayload } from './schema';
import createNewImageAsset from './factory/createNewImageAsset';
import { lazyInitializeAttachmentFilePicker } from 'owa-attachment-filepicker';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { AssetAriaLabel, registerAsset } from 'owa-timestream-asset-sdk';
import { DefaultCommand } from 'owa-timestream-asset-sdk-types';
import { isFeatureEnabled } from 'owa-feature-flags';

const IMAGE_TYPE = 'image';

export default registerAsset<ImagePayload>({
    type: IMAGE_TYPE,
    iconName: ControlIcons.FileImage,
    getToolName: () => loc(imageName),
    getTooltip: () => loc(imageTooltip),
    getErrorMessage: () => loc(assetErrorImage),
    isAssetEnabled: () => isFeatureEnabled('cal-board-imageAsset'),
    unsupportedDefaultCommands: [DefaultCommand.DueDate, DefaultCommand.Color],
    CanvasView: ImageView,
    createAssets: createNewImageAsset,
    createEmptyAsset: () => ({
        type: IMAGE_TYPE,
        payload: {
            filePickerLinkData: {
                fileName: '',
                mimeType: undefined,
                isFolder: false,
            },
            fileProvider: null,
            fileId: '',
            location: '',
            providerEndpointUrl: '',
            url: '',
            thumbnailUrl: '',
        },
    }),
    getAriaLabel: (payload: ImagePayload) =>
        loc(AssetAriaLabel.assetAriaLabel, loc(imageName), getImageName(payload)),
    getTitleString: getImageName,
    getSearchString: (payload: ImagePayload) => getImageName(payload) ?? payload.url,
    assetResizeConfiguration: () => ({
        minHeight: 150,
        minWidth: 150,
        defaultHeight: 200,
        defaultWidth: 200,
        maxHeight: 1000,
        maxWidth: 1000,
    }),
});

function getImageName(payload: ImagePayload) {
    return payload?.filePickerLinkData?.fileName;
}

// This preload needs to run before any code in this package will work.
lazyInitializeAttachmentFilePicker.import().then(preload => {
    preload();
});
